export function printReceipt(id) {
  const receipt = document.getElementById(id);
  if (!receipt) throw new Error('Receipt is not ready. Open the saved bill and try again.');
  if (!receipt.textContent.trim()) throw new Error('Receipt is empty. Reopen the saved bill before printing.');
  const frame = document.createElement('iframe');
  frame.title = '80 mm bill receipt';
  Object.assign(frame.style,{position:'fixed',width:'1px',height:'1px',left:'-10000px',border:'0'});
  document.body.appendChild(frame);
  const doc = frame.contentDocument;
  doc.open();
  doc.write('<!doctype html><html><head><title>Jaggi Sweets receipt</title><style>@page{size:80mm auto;margin:3mm}body{margin:0;color:#000;background:white;font:12px monospace}.flex{display:flex;justify-content:space-between}.text-center{text-align:center}.font-bold{font-weight:bold}hr{border:0;border-top:1px dashed #777;margin:8px 0}#lastReceipt,#searchReceipt{width:74mm!important;max-width:74mm!important;padding:0!important}</style></head><body></body></html>');
  doc.close();
  const copy=receipt.cloneNode(true);
  // Print the receipt itself, never its hidden/off-screen dashboard ancestor.
  copy.removeAttribute('hidden');
  Object.assign(copy.style,{display:'block',visibility:'visible',position:'static',width:'74mm',maxWidth:'74mm',color:'#000',background:'#fff'});
  doc.body.appendChild(copy);
  let timeout;
  const cleanup=()=>{clearTimeout(timeout);frame.remove();};
  frame.contentWindow.onafterprint=cleanup;
  // Give the isolated document a paint before opening the native print dialog.
  timeout=setTimeout(()=>{try{if(!doc.body.textContent.trim())throw new Error('Receipt could not be loaded. Reopen the saved bill and retry.');frame.contentWindow.focus();frame.contentWindow.print();}catch(error){cleanup();window.alert(error.message);}},150);
  setTimeout(()=>{if(frame.isConnected)cleanup();},300000);
}
